import React from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="relative bg-background text-foreground font-sans antialiased min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main className="min-h-screen">
        <section className="relative py-20 md:py-24">
          <div className="container relative mx-auto px-3 sm:px-4 lg:px-6 max-w-3xl">
            <h1 className="font-display text-4xl md:text-5xl font-extrabold leading-tight mb-6">Privacy Policy</h1>
            <p className="text-foreground/70 mb-8 italic">Last updated: 9/12/2025</p>
            <div className="prose prose-invert max-w-none">
              <p>
                At <strong>Paokhum</strong>, your privacy is important to us. We collect only the information we need to respond to your enquiries and deliver our services. This may include your name, contact details, and any information you share when you call or submit a form.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">What we collect</h2>
              <ul>
                <li>Basic contact details you choose to provide</li>
                <li>Anonymous analytics about how our website is used</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4">How we use it</h2>
              <ul>
                <li>To reply to your messages and deliver requested services</li>
                <li>To improve your website experience and our offerings</li>
              </ul>

              <p>
                We <strong>do not</strong> sell your data. We keep information only as long as needed for the purpose it was collected.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4">Contact</h2>
              <p>
                Questions about privacy? Call us at <a className="font-bold" href="tel:+919774477416"><strong>+91 9774477416</strong></a>.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;

